var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7378 0.54078L20.079 10.824C20.1794 11.133 20.4673 11.3422 20.7923 11.3422L31.6046 11.3422C31.8468 11.3422 31.9475 11.6521 31.7516 11.7945L23.0042 18.1498C22.7413 18.3408 22.6313 18.6793 22.7317 18.9883L26.073 29.2715C26.1478 29.5019 25.8842 29.6934 25.6882 29.551L16.9408 23.1957C16.678 23.0047 16.322 23.0047 16.0592 23.1957L7.31176 29.551C7.11583 29.6934 6.85221 29.5019 6.92705 29.2715L10.2683 18.9883C10.3687 18.6793 10.2587 18.3408 9.99581 18.1498L1.2484 11.7945C1.05248 11.6521 1.15317 11.3422 1.39535 11.3422L12.2077 11.3422C12.5327 11.3422 12.8206 11.133 12.921 10.824L16.2622 0.540777C16.3371 0.310453 16.6629 0.310449 16.7378 0.54078Z",
    stroke: "var(--icon-color)",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.4b581bbfde23c9b260e0bc8147a777e6.svg";
export { ForwardRef as ReactComponent };